// removed by extract-text-webpack-plugin
module.exports = {"visible":"RwfilA47"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/loadr/loadr.styles.scss
// module id = 754
// module chunks = 0